let reviews = [
    {
        name: 'Anonymous',
        review: 'I cannot say enough great things about LB Tile. They just completed a back splash in my kitchen. It is not only beautiful but the workmanship is QUALITY! They show up on time, answer all my questions, and they are super nice guys too. Planning my next project of a built in mudroom area with them.',
        rating: 5 
    },
    {
        name: 'Jane Smith',
        review: 'I am very satisfied with the service provided by LB Tile. The team was professional, efficient, and the quality of their work exceeded my expectations. I highly recommend them for any tile installation needs.',
        rating: 4 
    },
    {
        name: 'Michael Johnson',
        review: 'LB Tile did an amazing job on my bathroom renovation. The attention to detail and craftsmanship were outstanding. I am thrilled with the final result and would definitely use their services again.',
        rating: 5 
    },
    {
        name: 'Emily Davis',
        review: 'I had a great experience with LB Tile. They were prompt, courteous, and the quality of their work was excellent. I would highly recommend them to anyone looking for tile installation services.',
        rating: 4 
    }
];

export default reviews;